/**
 * Hook pour récupérer les événements du calendrier (Admin)
 */

import { useState, useEffect, useCallback } from 'react';
import { apiService } from '@/services/api';

export interface CalendarEventData {
  id: string;
  title: string;
  start: Date;
  end: Date;
  allDay: boolean;
  type: 'calendar_event' | 'booking';
  eventType?: string;
  description?: string;
  location?: string;
  capacity?: number;
  registeredCount?: number;
  organizerName?: string;
  bookingStatus?: string;
  spaceName?: string;
  spaceSlug?: string;
  customerName?: string;
  participantCount?: number;
  color?: string;
  accentColor?: string;
  reference?: string;
}

export function useCalendarEvents(start?: Date, end?: Date) {
  const [events, setEvents] = useState<CalendarEventData[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchEvents = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const params: Record<string, string> = {};
      if (start) params.start = start.toISOString();
      if (end) params.end = end.toISOString();

      const response = await apiService.getCalendarEvents(params);

      if (response.data.success) {
        const formattedEvents = response.data.events.map((event: any) => ({
          ...event,
          start: new Date(event.start),
          end: new Date(event.end),
        }));
        setEvents(formattedEvents);
      } else {
        setError('Erreur lors de la récupération des événements');
      }
    } catch (err) {
      console.error('Erreur fetch événements calendrier:', err);
      setError('Impossible de charger les événements du calendrier');
    } finally {
      setIsLoading(false);
    }
  }, [start, end]);

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  return {
    events,
    isLoading,
    error,
    refetch: fetchEvents,
  };
}
